import { TransportCatalogSearchCriteria } from '../../models';

export class TransportOrderCatalogLoad {
  public static readonly type = '[TransportOrderCatalog] Load';

  constructor(public payload: Partial<TransportCatalogSearchCriteria>) {}
}

export class TransportOrderCatalogInitialState {
  public static readonly type = '[TransportOrderCatalog] Set Initial State';
}
